module.exports = __webpack_public_path__ + "3-58.jpg?9fccbaf72c352715409db507014293e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-58.jpg
// module id = 140
// module chunks = 0